import type { TResellerBranding } from '@/reseller/reseller.types';

export const BRANDING: TResellerBranding = {
  consoleName: 'OrchestrationSuite',
  backofficeName: 'OrchestrationSuite Backoffice',
  abbreviation: 'SEW',
};
